import {CouponService} from "../resource";

const CouponModule = {
	namespaced: true,
	state: {
		datas: [],
		datas_detail: [],
		currentPage : 1,
		isLoading:false,
		datas: [],
		currentParams : {
			status: 0,
		}
	},
	mutations: { 
		SET_DATA(state, data) {
			state.datas = data;
		},
		SET_DATA_DETAIL(state, data) {
			state.datas_detail = data;
		},
		SET_CURRENT_PAGE(state, data) {
			state.currentPage = data;
		},
	},
	actions: {
		createData({ commit, state }, data) {
			return CouponService.CouponCreate(data);
		},

		updateData({ commit, state }, data) {
			return CouponService.CouponUpdate(data.id,data.payload);
		},
		deleteData({ commit, state }, data) {
			return CouponService.CouponDelete(data);
		},

		getData({ commit, state }, data) {
			return CouponService.CouponGet(data);
		},

		async listData({ commit, state }, data) {
			try
			{
				const response = await CouponService.CouponList(data);
				commit("SET_DATA", response.data.Data != null ? response.data.Data : []);
			}
			catch (error)
			{
				console.log(error);
				commit("SET_DATA", []);
			}
		},
		async listDataDetail({ commit, state }, data) {
			try
			{
				const response = await CouponService.CouponListDetail(data);
				commit("SET_DATA_DETAIL", response.data.Data != null ? response.data.Data : []);
			}
			catch (error)
			{
				console.log(error);
				commit("SET_DATA_DETAIL", []);
			}
		},
		async listDataDetailAll({ commit, state }, data) {
			try
			{
				const response = await CouponService.CouponListDetailAll(data);
				commit("SET_DATA_DETAIL", response.data != null ? response.data : []);
			}
			catch (error)
			{
				console.log(error);
				commit("SET_DATA_DETAIL", []);
			}
		},
		setCurrentPage({ commit, state }, data){
			console.log("SET_CURRENT_PAGE",data)
			commit("SET_CURRENT_PAGE",data)
		},
		setPlatformCurrentParams({ commit, state }, data){
			console.log("SET_CURRENT_PARAMS",data)
			commit("SET_CURRENT_PARAMS",data)
		},
		getCouponDocument({ commit, state }, data) {
            return CouponService.CouponGetDocument(data);
        },
		clearDataDetail({ commit, state }, data) {
			commit("SET_DATA_DETAIL", []);
		},
	
	},
	getters: {
		isLoading(state) {
			return state.isLoading;
		},
		getData(state) {
			return state.datas;
		},
		getDataDetail(state) {
			return state.datas_detail;
		},
		getCurrentPage(state) {
			return state.currentPage;
		},
	},
};

export default CouponModule;